/* eslint-disable  */
import * as React from 'react';
import Box from '@mui/material/Box';
import DataTable from "react-data-table-component";
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Stack,SvgIcon } from '@mui/material';
import VehicleForm from './vehicle';
import { default as VehicleList } from './vehiclelist';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '@mui/material/styles';
import {get}  from '../library/Api';
import {post,put} from '../library/Api';
import EditIcon from '@mui/icons-material/Edit';
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const EditForm = ({ theEmployee }) => {
  const [name, setName] = useState(theEmployee.firstName || '');
  const [lastName, setLastName] = useState(theEmployee.lastName || '');
  const [email, setEmail] = useState(theEmployee.email || '');
  const [phone, setPhone] = useState(theEmployee.mobile || '');
  const [regdate, setRegdate] = useState(theEmployee.regdate || '');
  const [account,setAccount] = useState(theEmployee.account || '')
  const [no_vehicle, setVehicle] = useState(theEmployee.vehicles || '');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [customer_id, setCustomer_id] = useState(theEmployee.customer_id || '');
  const [companyList, setCompanyList] = useState([]);
  const [show, setShow] = useState(false);
  const [rowData, setRowData] = useState([]);
  
  const [profile, setProfile] = useState(theEmployee.profile || '');
  const [company, setCompany] = useState(theEmployee.company || '');
  const [facilityCode,setfacilityCode] = useState(theEmployee.facility_code || '');
  const[cardId,setcardId] = useState(theEmployee.facilityCode || '');
  const [rfid, setRfid] = useState(theEmployee.rfid || '');
  const [building,setBuilding] = useState(theEmployee.building || "250  Assay Street");
  const [accessGroup,setAccessGroup] = useState(theEmployee.access_group || '');
  const [room, setRoom] = useState(theEmployee.room || '');
  const [addoption,setAddOPtion] = useState(false);
  const [garage,setGarage] = useState(theEmployee.garage || 'Garage Address');
  
  const[disablemode,setDisable] = useState(false);
  const [datas, setDatas] = useState([]);
  // const history = useHistory();
  const navigate = useNavigate();
  const columns = [
    {
      name: "Customer ID",
      selector: "customer_id",
      sortable: true,
      // cell: row => <div style={{fontSize: 20}}>{row.firstName}</div>
    },
    {
      name: "Model",
      selector: "make_model",
      sortable: true,
    },
    {
      name: "Colour",
      selector: "color",
      sortable: true,
    },
    {
      name: "License Plate",
      selector: "license_plate",
    },
    
    {
      name: "State",
      selector: "state",
    },
    // {
    //   name: "Parking Spot",
    //   selector: "parking_spot",
    // },
    // {
    //   name: "Company",
    //   selector: "company",
    // },
    {
      name: "Edit",
      selector: (row) => (
        <div>
           <a href="#" onClick={(e) => { console.log("this row = ",row)
      handleEdit(row);}} >
              <EditIcon />
            </a>
         
        </div>
      ),
    },
    // {
    //   name: "Delete",
    //   cell: (row) => (
    //     <div>
         
    //      <a href="#" 
    //           className="text-danger"  data-toggle="modal" >
    //           <DeleteOutlineIcon />
    //         </a>
    //     </div>
    //   ),
    // },
     
  ];

  const handleEdit = (row) =>{  setRowData(row);setShow(true); console.log("++++",rowData) }

  useEffect(() => {
    // console.log("customerid = ",theEmployee);
    setName(theEmployee.firstName || '');
    setLastName(theEmployee.lastName || '');
    setEmail(theEmployee.email || '');
    setPhone(theEmployee.mobile || '');
    setVehicle(theEmployee.vehicles || '');
    setIsSubmitted(false);
    setCustomer_id(theEmployee.customer_id || '');
    setRegdate(theEmployee.regdate || '');
    setAccount(theEmployee.account || '');
    setfacilityCode(theEmployee.facilityCode || '');
    setAccessGroup(theEmployee.access_group || '');
    setBuilding(theEmployee.building || '250  Assay Street')
    // console.log("-=================---reg Date --- >",theEmployee.regdate)
    setProfile(theEmployee.profile || '');
    setCompany(theEmployee.company || '');
    setRfid(theEmployee.rfid || '');
    setRoom(theEmployee.room || '');
    setGarage(theEmployee.garage || '');
    // console.log("from test customer------------------------------------")

    get(`get_company_list`).then((res) => {
      // const data = res;
      setCompanyList(res.data.companies)
    });
  }, [theEmployee]);

  useEffect(() => {
    if(customer_id){
    // console.log("------>>---custid---------->>--",cust_id)
    get(`list_vehicledata`,{params :{id:customer_id}}).then((res) => {
      const data = res;
      console.log("==",data.data);
      setDatas(data.data);
    
    },[]);}
  }, [customer_id]);
  const handleStateUpdate = (newValue) => {
    setAddOPtion(!addoption)
    return addoption;

    
  };
  const onChangeInput = (e, customer_id) => {
    const { name, value } = e.target;
    const editData = datas.map((item) =>
      item.customer_id === customer_id && name ? { ...item, [name]: value } : item
    )

    setDatas(editData);
    // post("insert_vehicledata", editData)
   
    // .then((response) => {
     
        
       
       
    //   })
     
    
    
  }
  const myNewTheme= {
    rows: {
      fontSize: '50px'
    }
  }
  const handlefacilityChange = (e) => {
    const newFacilityCode = e.target.value;
    setfacilityCode(newFacilityCode);
    const rfidcombined = newFacilityCode.concat(cardId);
    setRfid(rfidcombined);
  };

 const handleCardIdChange = (e) => {
    const newCardId = e.target.value;
    setcardId(newCardId);
    const rfidcombined = facilityCode.concat(":").concat(newCardId);
    setRfid(rfidcombined);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log()
    let data = {
      firstName: name,
      lastName: lastName,
      email: email,
      mobile: phone,
      account:account,
      vehicles: no_vehicle,
      customer_id : customer_id,
      company:company,
      profile:profile,
      rfid:rfid,
      building:building,
      facilitycode:facilityCode,
      cardId:cardId,
      regdate:regdate,
      room:room,
      garage:garage
    }
    
      // post("edit_customerdata", data).then((response) => {   
      // console.log(response.data);
      // if (response.status === 200) {
      // setIsSubmitted(true);
      // setDisable(!disablemode)
      //   // 1
      //   toast.success(`Sucessfully updated`, {
      //     autoClose: 1000, }); 
        
      // }
      // else{
      //   toast.error(`Error while updating`, {
      //         autoClose: 1000, });
      // }
      // })





      post("edit_customerdata", data).then(
        (response) => {
          console.log("data", response.data.message);
          if (response.data.message) {
            setTimeout(() => {
              toast.success(response.data.message);
              //  navigate("/user")
              // history.go(0);
              // window.location.reload();
            }, 500);
            
            
          } else {
            toast.error(`Failed to Edit Customer`);
          }
        },
        (error) => {
          //   toast.error(error.response.data.message, {
          //     autoClose: 3000,
          //   });
        }
      );

      // ,(error) => {
      //   //   toast.error(error.response.data.message, {
      //   //     autoClose: 3000,
      //   //   });
      //   }
  };



  // if (isSubmitted) {
  //   return <div>Form submitted successfully!</div>;
  // }

  return ( <>
   
    <form onSubmit={handleSubmit}>
      <Box
        component="div"
        sx={{
          '& .MuiTextField-root': { m: 0.5, width: '30ch' },
        }}
        noValidate
        autoComplete="off"
        className="mt-5 form-width"
      >
        <div>
        <h3 className="heading-style mb-4" >Customer Info</h3>
          {/*  */}
        {/* <TextField
                        type="text"
                        variant='outlined'
                        color='secondary'
                        label="First Name"
                        onChange={e => setFirstName(e.target.value)}
                        value={firstName}
                        fullWidth
                        required
                    /> */}
                    {/*  */}
                    <div className="text-end w-95 mt-1"> 
                    <FormControlLabel
                      control={<IOSSwitch sx={{ m: 2 }} defaultChecked = {!disablemode} onChange={() => setDisable(!disablemode)} />}
                      label="Editing Mode"
                    />   </div>

          <TextField
           type="text"
           color='secondary'
           className="mb-3"
           disabled={disablemode}
            required
            id="outlined-required"
            label="First Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant='outlined'
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
          type="text"
          disabled={disablemode}
          color='secondary'
          className="mb-3"
            id="outlined"
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            variant='outlined'
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
           type="text"
           color='secondary'
           className="mb-3"
            disabled 
            id="outlined-disabled"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant='outlined'
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
          type="text"
          color='secondary'
          className="mb-3"
            id="outlined"
            disabled={disablemode}
            label="Mobile No"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            // InputProps={{
            //   readOnly: true,
            // }}
            variant='outlined'
          />

            {/* -----------reg Date  */}
            <TextField
                    disabled
                    type="text"
                    variant="outlined"
                    color="secondary"
                    label="Registration Date"
                    onChange={(e) => setRegdate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    value={ regdate}
                    fullWidth
                    // required
                    sx={{ mb: 2 }}
                    />

          <TextField
          disabled
           type="text"
           color='secondary'
           className="mb-3"
          //  disabled={disablemode}
            id="outlined-number"
            label="Account"
            value={account || ''}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: 0,
              max: 150,
              step: 1,
            }}
            variant='outlined'
          />

          {/* <TextField
           type="text"
           color='secondary'
           className="mb-3"
            id="outlined-helperText"
            disabled={disablemode}
            label="RFID"
            // helperText="Some important text"
            variant='outlined'
          /> */}




          {/* --- */}

          <TextField
                    // type="text"
                    variant='outlined'
                    color='secondary'
                    disabled={disablemode}
                    label="Profile"
                    onChange={e => setProfile(e.target.value)}
                    value={profile}
                    fullWidth
                    required
                    select
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{mb: 2}}
                >
                <option key='vdsgh65' value=''> Please select </option>
                <option key='bt6g5g8' value='All Access'>All Access </option>
                <option key='lkjyub' value='Level 2'> Level 2 </option>
                <option key='lkhddb' value='GP'> GP </option>
                <option key='anvtre' value='Flash Test'> Flash Test </option>
                </TextField>

                <TextField
                    type="text"
                    select
                    variant='outlined'
                    disabled={disablemode}
                    color='secondary'
                    label="No Of Vehicles"
                    onChange={e => setVehicle(e.target.value)}
                    value={no_vehicle || '0'}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    required
                    className="mb-3"
                    sx={{mb: 2}} >  
                
                <option key='kfdrjh6' value='0'>  0 </option>
                <option key='45dsf4h' value='1'>  1 </option>
                <option key='fghghygh' value='2'>  2 </option>
                <option key='sd4fg7' value='3'>  3 </option>
                <option key='3454fgb' value='4'>  4 </option>
                </TextField>
                
                {/* <Stack spacing={2} direction="row" sx={{marginBottom: 2}}> */}

                <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    disabled={disablemode}
                    label="Facility Code"
                    onChange={handlefacilityChange}
                    value={facilityCode}
                    className="mb-3"
                />

                 <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    disabled={disablemode}
                    label=" Card Id" 
                    onChange={handleCardIdChange}
                    value={cardId}
                    className="mb-3"
                />
                {/* </Stack> */}

                <TextField
                        type="text"
                        disabled
                        variant="outlined"
                        color="secondary"
                        
                        label="RFID"
                        // onChange={handleNameChange}
                        value={rfid}
                        className="mb-3"
                    />
                    

                     <TextField
                  className="mb-3"
                  disabled={disablemode}
                  label="Select Company"
                  name="name"
                  onChange={(e) => setCompany(e.target.value)}
                  required
                  select
                  value={company}
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                >
                  <option key='' value=''> Please select </option>
              {companyList.map((company) => ( <option key={company} value={company}>{company}</option>))}
                </TextField>

                <TextField
                    type="text"
                    select
                    disabled={disablemode}
                    variant='outlined'
                    color='secondary'
                    label="Building"
                    onChange={e => setBuilding(e.target.value)}
                    value={building}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    required
                    sx={{mb: 2}} >  
                 <option key='bv' value='1'>  250  Assay Street</option>
                </TextField>



                <TextField
                    type="text"
                    select
                    disabled={disablemode}
                    variant='outlined'
                    color='secondary'
                    
                    label="Garage Address"
                    // onChange={e => setVehicle(e.target.value)}
                    value={garage}
                    className="mb-3"
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    required
                    sx={{mb: 2}}
                >  
                 <option key='ga1' value='Garage Address'>   707 Redemption</option>
                </TextField>
                
                {/* <Stack spacing={2} direction="row" sx={{marginBottom: 2}}> */}
                <TextField
                    // type="text"
                    variant='outlined'
                    color='secondary'
                    disabled={disablemode}
                    label="Building Access Group"
                    onChange={e => setAccessGroup(e.target.value)}
                    value = {accessGroup}
                    className="mb-3"
                    required
                    select
                    InputLabelProps={{ shrink: true }}
                    SelectProps={{ native: true }}
                    sx={{mb: 2}}
                >   <option key='kdjs7' value='admin'> Admin </option>
                <option key='h3j' value='Apache'> Apache </option>
                <option key='g3' value='Caprock'> Caprock </option>
                <option key='g65' value='Nimble'>Nimble </option>
                </TextField>
                {accessGroup === 'Nimble' && (<TextField
                  className="mb-3"
                  label="Select Room"
                //   name="name"
                  onChange={(e) => setRoom(e.target.value)}
                  value = {room}
                  select
                  InputLabelProps={{ shrink: true }}
                  SelectProps={{ native: true }}
                  sx={{ mb: 2 }}
                //   value={values.state}
                >
                  <option key='d445d' value=''> Please select </option>
                  <option key='45d' value='sky'> Room1 </option>
                 <option key='554' value='sgygy'> Room- 2 </option>
                 <option key='g4' value='kjhdjs'> Room 3 </option>
                </TextField>)}
                {/* </Stack> */}

          {/* ------- */}
           
        </div>
        <div className="text-end w-100 mt-1">
        <input type="submit" value="Submit"  disabled={disablemode} className="mb-4 btn btn-primary btn-sty" />
        </div>
      </Box>

      
        
      <div  className="mt-5 form-width"> 

       <VehicleList vehiclelist_data={customer_id} updateVisibility = {handleStateUpdate} />
       <div className="container">
       {/* <h3 className="heading-style">
        Vehicle Details
      
      </h3>
      <table>
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Model</th>
            <th>color</th>
            <th>License Plate</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {datas.map(({ customer_id, make_model, color, license_plate ,state }) => (
            <tr key={customer_id}>
              <td>
                <input
                  name="Customer ID"
                  value={customer_id}
                  type="text"
                  onChange={(e) => onChangeInput(e, customer_id)}
                  placeholder="CustomerID"
                />
              </td>
              <td>
                <input
                  name="Model"
                  value={make_model}
                  type="text"
                  onChange={(e) => onChangeInput(e, customer_id)}
                  placeholder="Change Model"
                />
              </td>
              <td>
                <input
                  name="Colour"
                  type="text"
                  value={color}
                  onChange={(e) => onChangeInput(e, customer_id)}
                  placeholder="Type Position"
                />
              </td>
              <td>
                <input
                  name="License Plate"
                  type="text"
                  value={license_plate}
                  onChange={(e) => onChangeInput(e, customer_id)}
                  placeholder="Type Position"
                />
              </td>
              <td>
                <input
                  name="state"
                  type="text"
                  value={state}
                  onChange={(e) => onChangeInput(e, customer_id)}
                  placeholder="Type Position"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}


{/* <Box sx={{ display: 'flex' }}>
   
    <Box component="main" sx={{ flexGrow: 1, p: 0, mt: 0  }}>
    <div className="App">
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h3 className="heading-style">
        Vehicle Details
      
      </h3>

      <div>

        <Button
        className="btn-sty"
        
          startIcon={
            <SvgIcon fontSize="small">
              <PlusIcon />
            </SvgIcon>
          }
          variant="contained"
        >
         
          ADD
        </Button>
      </div>
      </div>
      <DataTable
        title=""
        columns={columns}
        data={datas}
        highlightOnHover
        customTheme={myNewTheme}
       
        className="table-style"
      />
    </div>
    </Box>
    </Box> */}
        {/* ----------------in edit  */}

    <div>
    
    </div>



    </div>

        </div>
        { addoption && (     
      <div  className="mt-5 form-width">
      {/* {customer_id : 45,name:" new name",vehicles:4}} }*/}
          <VehicleForm vehicle_form_data={{customer_id:customer_id, name:name+' ' +lastName,vehicles:no_vehicle ,company:company } } update_visibility = {handleStateUpdate}/>
        </div> )}


          <br />
       
    
       
     
    
    </form>
  
   
    
    </>
  );
};

export default EditForm;
